export default __webpack_public_path__ + "static/media/de.7e82f4c7.svg";